<template>
  <div class="app-container">
    <CrudTable entity="Configuration" :columns="columns" :allow-create="false" :allow-delete="false" />
  </div>
</template>

<script>
import CrudTable from '@/components/crud/CrudTable';
export default {
  components: {
    CrudTable
  },
  data() {
    return {
      columns: [
        { field: 'code', label: 'configuration.code' },
        'description',
        { field: 'value', label: 'configuration.value' },
        {
          field: 'fromDate',
          label: 'configuration.fromDate',
          type: 'dateTime'
        }
      ]
    };
  }
};
</script>

<style scoped></style>
